(function($, undefined) {
	
	'use strict';
	var faqQuestion;
    var faqAnswer;

    var toggleFaqAnswer = function() {
        var t = $(this);
        var questionCtn = t.closest('.faq-question-outer-ctn');
        var relatedAnswer = questionCtn.find(faqAnswer);

        if (questionCtn.hasClass('open')) {
            questionCtn.removeClass('open');
            relatedAnswer.slideUp(300);
        } else {
            questionCtn.addClass('open');
            relatedAnswer.slideDown(300);
        }
    };
	
	var init = function () {
        faqQuestion = $('body:not(.is-logged-in) .faq-question-header-ctn');
        faqAnswer = $('.faq-answer-ctn');

        faqQuestion.click(toggleFaqAnswer);
	};
	
	init();
	
})(jQuery);
